// blog post hover events
// similar code is written inline for features-posts-row
// TODO: refactor articles to component maybe
// TODO: see how to refactor this to set eventListener to grid to avoid recalling this function each layout change
export default function blogPostHoverEvents()
{
    const articles = document.querySelectorAll('.archive-post-grid article')
    let timeoutHandler
    articles.forEach(article => article.addEventListener('mouseenter', e => {
        clearTimeout(timeoutHandler)

        e.target.style.height = e.target.clientHeight + 'px'
        e.target.classList.add('hover')
    }))
    articles.forEach(article => article.addEventListener('mouseleave', e => {
        e.target.classList.remove('hover')
        timeoutHandler = setTimeout(() => {
            e.target.style.removeProperty('height')
        }, 500)
    }))
}
